import client from '/src/services/client.js';

export default {
    getBotProfiles : (companyId) => client.get(`company/${companyId}/profil`),
}
